var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 183,
    viewBox: "0 0 182 183",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-16%",
    y: "-15.3%",
    width: "133.3%",
    height: "133.3%",
    filterUnits: "objectBoundingBox",
    id: "47trsr9zya"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.306947508 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "faijpjw4db",
    cx: 75,
    cy: 75,
    r: 75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 150c41.421 0 75-33.579 75-75-17.905 32.088-48.651 44.693-65.05 47.449-19.138 3.216-40.95 3.813-74.349-8.984C23.701 135.349 47.64 150 75 150z",
    id: "bqmcl0bygc"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 14.117)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#47trsr9zya)",
    xlinkHref: "#faijpjw4db"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#faijpjw4db"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.15,
    fill: "#272666",
    xlinkHref: "#bqmcl0bygc"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    cx: 75,
    cy: 75,
    r: 74.5
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FFF",
    cx: 75,
    cy: 75,
    r: 74.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleShadow);
export default __webpack_public_path__ + "static/media/circle-shadow.e2e020eb6f0b09c7bd9095a101ae0ab7.svg";
export { ForwardRef as ReactComponent };